export default {
	methods: {
		get_data(data, metadata) {
			for (let s = 0; s < metadata.length; s++) {
				if (metadata[s].id == data) return metadata[s].value;
			}
			return data;
		},
	},
};



// WEBPACK FOOTER //
// ./src/components/order-of-service/components/actions-components/js/getData.mixins.js